const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const initialState = Immutable.fromJS({
    valid: false
});

function validateStep(state, valid) {
    return state.merge({
        valid: valid
    });
}

function hirePackOpenYoungStep5(state = initialState, action = { type: null }) {
    switch (action.type) {
        case actionTypes.HIRE_PACK_OPEN_YOUNG_VALIDATE_STEP:
            return validateStep(state, action.payload.valid);

        default:
            return state;
    }
}

module.exports = hirePackOpenYoungStep5;
